import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Graphics, Sprite, Text } from '@pixi/react';
import { gsap } from 'gsap';
import { getGameImages } from '../../../core/helpers/getGameImages';
import GambleHistoryCard from './gambleHistoryCard';
import { GAMBLE_CARDS } from '../../../core/constants/gameConstants';
import { isMobile } from '../../../core/helpers/isMobile';
import { applicationStore } from '../../../store/applicationStore';

function GambleHistory({ x, y, history }) {
  const containerRef = useRef();
  const [mask, setMask] = useState(null);

  const { historyClosedCard, historyRedCard, historyBlackCard } = useMemo(() => {
    return getGameImages();
  }, []);

  const cardImages = useMemo(() => {
    return {
      [GAMBLE_CARDS.Red]: historyRedCard,
      [GAMBLE_CARDS.Black]: historyBlackCard,
    };
  }, [historyRedCard, historyBlackCard]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.mask = mask;
    }
  }, [mask, containerRef]);

  useEffect(() => {
    if (!history.length || history.length > 5) {
      return;
    }
    if (containerRef.current) {
      gsap.to(containerRef.current, {
        x: `-=${isMobile() ? 20 : 30}`,
        duration: 0.6,
        ease: 'none',
        onComplete: () => {},
      });
    }
  }, [history, containerRef]);

  useEffect(() => {
    if (history.length && history.length <= 5) {
      containerRef.current.x = 451 - (history.length - 1) * (isMobile() ? 20 : 30);
    } else if (history.length > 5) {
      containerRef.current.x = 451 - (isMobile() ? 100 : 150);
    } else {
      containerRef.current.x = 451;
    }
  }, []);

  useEffect(() => {
    const currentGsap = containerRef.current;
    return () => {
      gsap.killTweensOf(currentGsap);
    };
  }, [containerRef]);

  return (
    <Container x={x} y={y}>
      <Text
        x={isMobile() ? 450 : 453}
        y={isMobile() ? 47 : 28}
        text={applicationStore.canvasTranslationKeys.GAMBLE_FEATURE}
        style={{ fill: '#FFFFFF', fontSize: 16, fontWeight: 500 }}
        anchor={0.5}
        resolution={2}
      />
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill(0xff700b);
          g.drawRect(
            isMobile() ? 330 : 270,
            isMobile() ? 62 : 46,
            isMobile() ? 245 : 364,
            isMobile() ? 62 : 92
          );
        }}
        ref={(graphicsRef) => setMask(graphicsRef)}
      />
      <Container ref={containerRef} y={93}>
        <Container x={3}>
          {history.map(({ card, index }, i) => {
            return (
              <GambleHistoryCard
                key={index}
                index={i}
                cardTexture={cardImages[card]}
                history={history}
              />
            );
          })}
        </Container>
        <Sprite texture={historyClosedCard} anchor={0.5} />
      </Container>
    </Container>
  );
}

export default GambleHistory;
